import React, { useCallback, useState } from "react";
import Image from "next/image";
import Scroller from "@/components/common/Scroller/Scroller";
import AppPopup from "./AppPopup";
import RenderTypePreviewData from "@/components/common/RenderTypePreviewData/RenderTypePreviewData";
import useShareOnMobile from "@/hooks/tools/useShareOnMobile";
import { IQrType } from "@/types/qr.types";
import { TfiClose } from "react-icons/tfi";
import { FiShare2 } from "react-icons/fi";
import useQrPayloadStore from "@/components/page-modules/builder/__shared/data/builder.store";
import { QR_TYPES } from "@/constant/qr_type.enum";
import cn from "classnames";
import style from "./AppPreview.module.scss";
import { UserSocialType } from "@/types/user.types";
import useIsDashboard from "@/hooks/common/useIsDashboard";
export const detectImgAccordingType = (type: string) => {
  if (type === "app_store") {
    return "/dashboard-assets/apple.svg";
  }
  if (type === "google_play") {
    return "/dashboard-assets/googleplay.svg";
  } else {
    return "/dashboard-assets/amazon.svg";
  }
};
const App = ({
  from,
  slug,
  data: apiData
}: IQrType) => {
  const [data] = useQrPayloadStore(state => [state.data[QR_TYPES.APP]]);
  const currentData = apiData || data;
  const {
    payload,
    files
  } = currentData;
  const [isPopup, setIsPopup] = useState<boolean>(false);
  const [isSocialPopup, setSocialPopup] = useState<boolean>(false);
  const [isLearnMorePopup, setLearnMorePopup] = useState<boolean>(false);
  const [popupText, setPopupText] = useState<string>("");
  const isDashboard = useIsDashboard();
  const {
    shareData
  } = useShareOnMobile();
  const handleSharePopup = () => {
    if (isDashboard) {
      setIsPopup(prev => !prev);
    } else {
      shareData({
        initialData: {
          sharingData: {
            title: "App",
            text: "",
            url: process.env.NEXT_PUBLIC_PREVIEW_TYPES_URL + slug!
          }
        }
      });
    }
  };
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string, text: string) => {
    if (!url) {
      e.preventDefault();
      if (text) {
        setSocialPopup(true);
        setPopupText(text);
      } else {
        setLearnMorePopup(true);
      }
    }
  }, []);
  return <div className={style.wrapper} data-sentry-component="App" data-sentry-source-file="index.tsx">
      <style>
        {`
          .scroll-content {
            height: 423px;
        
            > div {
              height: 100%;
            }
          }
        
          .scrollbar-track {
            display: none !important;
          }
        `}
      </style>
      <Scroller data-sentry-element="Scroller" data-sentry-source-file="index.tsx">
        <div className={style.share_btn} onClick={handleSharePopup}>
          {isPopup && isDashboard ? <TfiClose color={"#fff"} size={20} /> : <FiShare2 color={"#fff"} size={20} />}
        </div>
        <div className={cn(style.back, {
        [style.fromType]: from === "type"
      })} style={{
        "--backcolor": payload.design_colors_primary
      } as React.CSSProperties}>
          <div className={style.title}>
            <div className={style.top}>
              <RenderTypePreviewData data={payload.app_name} fakeData={"App Name"} from={from} data-sentry-element="RenderTypePreviewData" data-sentry-source-file="index.tsx" />
            </div>
            <div className={style.des}>
              <RenderTypePreviewData data={payload.developer} fakeData={"Name Of App Developer"} from={from} data-sentry-element="RenderTypePreviewData" data-sentry-source-file="index.tsx" />
            </div>
          </div>
          <div className={style.img_box}>
            <Image src={!files?.logo?.url ? "/dashboard-assets/defaultImageApp.svg" : files.logo.url} alt={files?.logo?.originalName || ""} width={115} height={115} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          </div>
          <div className={style.content}>
            <div className={style.title}>
              <RenderTypePreviewData data={payload.title} fakeData={"Page Title"} from={from} data-sentry-element="RenderTypePreviewData" data-sentry-source-file="index.tsx" />
            </div>
            <p className={style.des}>
              <RenderTypePreviewData data={payload.description} fakeData={"Brief Description Of Your App"} from={from} data-sentry-element="RenderTypePreviewData" data-sentry-source-file="index.tsx" />
            </p>
            {payload.button && <div className={style.btn_box}>
                <a href={payload.button_url} target="_blank" rel="noopener noreferrer" onClick={e => handleClick(e, payload.button_url, "")}>
                  {payload.button}
                </a>
              </div>}
            <div className={style.social_box}>
              {payload?.socialItems.map((item: UserSocialType, index: number) => <div className={style.item} key={index.toString() + item.type}>
                  <a href={item.url} target="_blank" rel="noopener noreferrer" onClick={e => handleClick(e, item.url, item.text || "")}>
                    <img src={detectImgAccordingType(item.type)} alt="Social Item" />
                    <span>{item.text}</span>
                  </a>
                </div>)}
            </div>
            <RenderTypePreviewData data={payload.website} fakeData={"www.website.com"} from={from} element={({
            content
          }) => <a className={style.website} onClick={e => handleClick(e, payload.website, "")} target={"_blank"} rel="noopener noreferrer" href={payload.website}>
                  {content}
                </a>} data-sentry-element="RenderTypePreviewData" data-sentry-source-file="index.tsx" />
          </div>
        </div>
      </Scroller>
      {isPopup && isDashboard ? <AppPopup text={"Tapping this button allows users to share your page."} setIsShow={setIsPopup} /> : isSocialPopup && isDashboard ? <AppPopup store={popupText} setIsShow={setSocialPopup} /> : isLearnMorePopup && isDashboard ? <AppPopup text={"After clicking the button, the user will be taken to the website of your choice."} setIsShow={setLearnMorePopup} /> : <></>}
    </div>;
};
export default App;